import AbstractModal from 'static/script/utils/abstract-modal';
import JST from 'static/script/templates/templates';

// This Component extends AbstractModal
function FilterModalUI() {
    this.defaultAttrs({
        filterLink: '.modal-tags a[data-nav]',
        filterFakeLink: '.modal-tags [data-javascript-href]',
        filterInput: '.modal-tags [data-input-tag-filter]',
        contentItem: '.modal-tags .tag-navigation-filter-list-item',
        navigateEvent: 'ui:modal-filter-ui:on-load',
        tagListSelector: '.tag-navigation-filter-list-item', // @Todo: Change to data attribute
        sectionSelectorPrefix: '.tag-navigation-filter-',

        addBrandModalButton: '[data-filter-add-brand-button]'
    });

    this._getSectionSelector = function() {
        return (
            this.attr.sectionSelectorPrefix +
            this.payload.modalType +
            ':eq(0) ' +
            this.attr.tagListSelector
        );
    };

    this._triggerOpen = function(evt, payload) {
        this.payload = payload;
        this.parentNode = payload.parentNode;
        payload.content = this._getContent({
            placeholder: payload.placeholder
        });
        this.openModal(payload);
    };

    this._updateContent = function() {
        if (this._isActive()) {
            let content = this._getContent({
                placeholder: this.payload.placeholder
            });
            this.$modalContent.html(content);
        }
    };

    this._getContent = function(options) {
        let list = this._getListContent(),
            filterInput = this._getSearchFilterContent(options),
            content = $('<div class="tag-modal-content"></div>'),
            feedbackOpener = this._getFeedbackOpener();
        // addBrandForm = this._getAddBrandForm();

        return content
            .append(filterInput)
            .append(list)
            .append(feedbackOpener);
    };

    this._getFeedbackOpener = function() {
        let options = {
            feedbackKey: 'Brand tags',
            feedbackTitle:
                'Hur tycker du att det fungerar att filtrera på varumärke?',
            feedbackLinkText: 'Vad tycker du om att filtrera på varumärke?',
            feedbackCssClass: 'search-result-brand-tag-feedback-popup',
            feedbackOpenerCssClass: 'search-result-brand-tag-feedback'
        };

        return JST['templates/feedback-opener.html'](options);
    };

    this._getListContent = function() {
        let sorter = function(a, b) {
            let aTxt = $(a)
                    .find('.search-filters-list-item-label')[0]
                    .innerHTML.toUpperCase(),
                bTxt = $(b)
                    .find('.search-filters-list-item-label')[0]
                    .innerHTML.toUpperCase();

            if (aTxt < bTxt) {
                return -1;
            } else if (aTxt > bTxt) {
                return 1;
            }
            return 0;
        };
        let ol = $('<ol class="tag-modal-list"></ol>');
        // var suggestButton = $('<li><button class="text-action link">Saknas något?</button></li>');
        // var list = $(this._getSectionSelector()).clone();
        // return ol.append(list.sort(sorter)).append(suggestButton);

        let list = $(this._getSectionSelector()).clone();
        return ol.append(list.sort(sorter));
    };

    this._getAddBrandForm = function() {
        return JST['templates/filter-add-brand-form.html']();
    };

    this._getSearchFilterContent = function(options) {
        return JST['templates/filter-tags-input-template.html']({
            placeholder: options.placeholder
        });
    };

    this._onChange = function(evt, payload) {
        let items = this.select('contentItem');
        this.query = $(payload.el)
            .val()
            .toLowerCase()
            .trim();

        if (this.query.length < 1) {
            items.removeClass('hidden');
        } else {
            _.map(
                items,
                function(item) {
                    let $item = $(item);
                    let label = $item
                        .find('.search-filters-list-item-label')
                        .text()
                        .toLowerCase()
                        .trim();
                    if (label.indexOf(this.query) === 0) {
                        $item.removeClass('hidden');
                    } else {
                        $item.addClass('hidden');
                    }
                }.bind(this)
            );
        }
    };

    this._addGaTracking = function() {
        if (
            this.query &&
            this.query.length > 0 &&
            this.query !== this.lastTrackedQuery
        ) {
            this.lastTrackedQuery = this.query;
            this.trigger('analytics:track-event', {
                category: 'Search Filters',
                action: 'Client Filter',
                label: 'Lost focus with query: ' + this.query
            });
        }
    };

    this._filterClick = function(evt) {
        evt.preventDefault();
        let $currentTarget = $(evt.currentTarget);
        let href =
            typeof $currentTarget.attr('data-javascript-href') === 'undefined'
                ? $currentTarget.attr('href')
                : $currentTarget.attr('data-javascript-href');

        this._lastTarget = $currentTarget;
        this.trigger(document, this.attr.navigateEvent, { href: href });
    };

    this._afterFilterLoad = function(evt, payload) {
        this.parentNode = payload.parentNode;
        this._updateContent();
    };

    this._closeClick = function(evt) {
        if (!this._isActive()) {
            return;
        }
        if (this._closePrevented) {
            return;
        }

        let target = $(evt.target);
        if (target.attr('data-modal-close') === undefined) {
            return;
        }
        evt.stopPropagation();
        this._close();
        this.trigger('ui:modal-filter-ui:on-modal-close');
    };

    this.after('initialize', function() {
        this.lastTrackedQuery = '';

        this.on('keyup', {
            filterInput: this._onChange
        });

        this.on('focusout', {
            filterInput: this._addGaTracking
        });

        this.on('click', {
            filterLink: this._filterClick,
            filterFakeLink: this._filterClick,
            addBrandModalButton: this._openBrandModal
        });

        this.on(
            document,
            'data:navigation-filter:after-load',
            this._afterFilterLoad
        );
        this.on(
            document,
            'ui:search-result:on-open-filters',
            this._triggerOpen
        );
    });
}

export default AbstractModal.mixin(FilterModalUI);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/search-result/filter-modal-ui.js